<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="this.$store.state.auth.layout.notification_button" @click.native="handleBellClick">
    <span class="notification-bell cursor-pointer mt-1 sm:mr-6 mr-2">
      <feather-icon icon="BellIcon" />
      <span v-if="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
    </span>

    <!-- :badge="notifications.length" -->

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <!-- <h4 v-if="unreadCount > 0 && notifications.length > 0" class="text-white">{{ unreadCount }} Novas atualizações</h4> -->
        <h4 v-if="notifications.length === 0" class="text-white">{{ $t('NOTIFICATION.NoUpdates') }}</h4>
        <h4 v-else-if="notifications.length > 0" class="text-white">{{ $t('NOTIFICATION.LatestUpdates') }}</h4>
        <!-- <p class="opacity-75">App Notifications</p> -->
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li v-for="ntf in notifications" :key="getNotificationKey(ntf)" :class="`flex justify-between px-4 py-4 notification ${ntf.url ? 'cursor-pointer' : ''}`" @click="handleNotificationClick(ntf)">
            <div class="flex items-start">
              <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.color}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.color}`]">{{ ntf.title }}</span>
                <small>{{ ntf.description }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.timestamp) }}</small>
          </li>
        </ul>
      </component>

      <!-- <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <span>View All Notifications</span>
      </div> -->
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { performFetch, setApplicationLocalStorageItem } from '../../../../helpers';

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      notifications: [],
      isOpen: false,
      pollingTimer: null,
      pollingIntervalMs: 60000,
      pollingBackoffMs: 120000,
      lastNotificationTimestamp: null,
      // notifications: [

      // ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      clicking: false
    }
  },
  computed: {
    scrollbarTag () {
      return this.$store.getters.scrollbarTag }
    ,
    unreadCount () {
      return this.notifications.filter(notification => !notification.read).length
    }
  },
  async mounted() {
    await this.getNotifications();
    this.setupPolling()
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    this.clearPolling()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  watch: {
    // isOpen(newVal) {
    //   if(newVal) {
    //     const unreadNotificationsIds = this.notifications.map(notification => {
    //       if(!notification.read) {
    //         return notification.id
    //       }
    //     });

    //     console.log(unreadNotificationsIds)
    //   }
    // }
  },
  methods: {
    // setIsOpen() {
    //   if (!this.clicking) {
    //     this.clicking = true;
    //     this.isOpen = !this.isOpen;
    //     setTimeout(() => {
    //       this.clicking = false;
    //     }, 300); // Tempo para evitar múltiplos cliques rápidos
    //   }
    // },
    setupPolling() {
      this.clearPolling()
      this.scheduleNextPoll(this.pollingIntervalMs)
    },
    clearPolling() {
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    scheduleNextPoll(delay) {
      this.pollingTimer = setTimeout(async () => {
        await this.getNotifications(true)
        const isHidden = document.hidden
        const nextDelay = isHidden ? this.pollingBackoffMs : this.pollingIntervalMs
        this.scheduleNextPoll(nextDelay)
      }, delay)
    },
    onVisibilityChange() {
      if (!document.hidden) {
        this.getNotifications(true)
      }
    },
    async handleBellClick() {
      await this.markAllNotificationsRead()
    },
    async handleNotificationClick(notification) {
      if (!notification) {
        return
      }

      const notificationUrl = notification.url
      if (notificationUrl) {
        window.open(notificationUrl)
      }

      await this.markNotificationRead(notification)
    },
    async getNotifications(isPolling = false) {

      const parameters = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token
      }

      const userHash = this.getCurrentUserHash()
      if (userHash !== null) {
        parameters.user_hash = userHash
      }
      if (this.lastNotificationTimestamp) {
        parameters.since_timestamp = this.lastNotificationTimestamp
      }

      await performFetch(this.$store.state.auth.api_url, {
        command: "get_application_notifications",
          parameters
      })
      .then(async response => {
        if(response.status === 200) {
          const data = await response.json()

          const list = Array.isArray(data.notifications) ? data.notifications : []
          const normalized = list.map(notification => ({
            ...notification,
            read: Boolean(notification.read)
          }))
          if (normalized.length > 0) {
            this.lastNotificationTimestamp = normalized[0].timestamp
          }
          if (isPolling) {
            const merged = [...normalized, ...this.notifications]
            const seen = new Set()
            this.notifications = merged.filter(notification => {
              const key = this.getNotificationKey(notification)
              if (seen.has(key)) {
                return false
              }
              seen.add(key)
              return true
            })
          } else {
            this.notifications = normalized
          }
        } else if (response.status === 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          }
      })
      .catch(e => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Atenção!",
          text: 'Ocorreu um erro ao carregar as notificações.',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        throw new Error(e.message);
      })

    },
    getCurrentUserHash() {
      const user = this.$store.state.auth.user
      const userObject = typeof user === 'string' ? JSON.parse(user) : user
      const userHash = userObject && (userObject.hash || userObject.user_hash)
      return userHash && typeof userHash === 'string' ? userHash : null
    },
    async markAllNotificationsRead() {
      const unreadIds = this.notifications
        .filter(notification => !notification.read && notification.id !== undefined && notification.id !== null)
        .map(notification => Number(notification.id))
        .filter(id => Number.isInteger(id))

      if (unreadIds.length === 0) {
        return
      }

      const response = await performFetch(this.$store.state.auth.api_url, {
        command: "mark_application_notification_read",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          notification_ids: unreadIds
        }
      })

      if (response.status === 200) {
        this.notifications = this.notifications.map(notification => ({
          ...notification,
          read: true
        }))
      }
    },
    async markNotificationRead(notification) {
      const notificationId = notification ? Number(notification.id) : null
      if (!notification || notification.read || !Number.isInteger(notificationId)) {
        return
      }

      const response = await performFetch(this.$store.state.auth.api_url, {
        command: "mark_application_notification_read",
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          notification_id: notificationId
        }
      })

      if (response.status === 200) {
        notification.read = true
      }
    },
    getNotificationKey(notification) {
      if (!notification) {
        return ''
      }
      if (notification.id !== undefined && notification.id !== null) {
        return String(notification.id)
      }
      if (notification.timestamp) {
        return `${notification.timestamp}-${notification.title || ''}`
      }
      return notification.title || ''
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Anos ' : ' Ano ')}atrás`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Dias ' : ' Dia ')}atrás`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hora ')}atrás`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}atrás`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' segundos atrás' : 'agora mesmo')
      }

      return 'Agora Mesmo'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  }
}

</script>

<style scoped>
.notification-bell {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.notification-badge {
  position: absolute;
  top: -4px;
  right: -6px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ea5455;
  color: #fff;
  font-size: 0.65rem;
  line-height: 16px;
  text-align: center;
  font-weight: 600;
}
</style>

